module.exports = __webpack_public_path__ + "img/1503452874.cd77e199.jpg";